export enum AllergenContentType {
  MayContain = 1,
  Contains = 2
}

(AllergenContentType as any).__typeName = 'ProductAllergenContentType';
